import {useEffect, useState} from "react";
import {createRoot} from 'react-dom/client';
import {Provider} from "react-redux";

import App from './App';
import store from "./store";
import reportWebVitals from './reportWebVitals';
import NetworkModal from "./components/modals/NetworkModal";
import {getStoreOnReload, setOrganisationHeader} from "./store/actions/auth.action";

import './index.css';
import "./assets/scss/style.scss";
import "./assets/scss/extra.scss";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {GeneralAppInfo} from "./utils/helpers/constants";


getStoreOnReload(store);
setOrganisationHeader(store).catch(err => console.log(err));

const AppRoot = () => {
  const [networkStatus, updateNetworkStatus] = useState(navigator.onLine);
  const updateNetwork = () => updateNetworkStatus(navigator.onLine);
  useEffect(() => {
    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
    };
  }, []);

  const networkRender = !(networkStatus) ? <NetworkModal/> : null

  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GeneralAppInfo.GOOGLE_AUTH_KEY}>
        <App/>
        {networkRender}
      </GoogleOAuthProvider>
    </Provider>
  )
}

const root = createRoot(document.getElementById('root'));
root.render(<AppRoot/>);

reportWebVitals();
